export enum TranslationsMx {
  YEAR_MONTH_DAY = '{year}-{month}-{day}',
  MON = 'Lunes',
  TUE = 'Martes',
  WED = 'Miercoles',
  THU = 'Jueves',
  FRI = 'Viernes',
  SAT = 'Sabado',
  SUN = 'Domingo',
  STREET_ADDRESS1 = 'Direccion 1',
  STREET_ADDRESS2 = 'Direccion 2',
  CITY = 'Ciudad',
  STATE = 'Estado',
  ZIP_CODE = 'Codigo postal',
  COUNTRY = 'Pais',
  OK = 'Ok',
  CANCEL = 'Cancelar',
  CONFIRMATION = 'Confirmacion',
  ARE_YOU_SURE_YOU_WANT_TO_CANCEL = 'Estas seguro de querer cancelar?',
  STEP = 'Paso',
  OF = 'de',
  PREVIOUS = 'Anterior',
  NEXT = 'Siguiente',
  SAVE = 'Guardar',
  SAVE_AND_NEXT = 'Guardar y continuar',
  SUBMIT = 'Enviar',
  CLOSE = 'Cerrar',
  ENLARGED_ATTACHMENT = 'Adjunto ampliado',
  NO_INFO = 'No hay informacion',
  BEDROOMS = 'Habitaciones',
  BATHROOMS = 'Baños',
  HOME = 'Casa',
  PROGRESS = 'Progreso',
  START_DATE = 'Fecha de inicio',
  END_DATE = 'Fecha de fin',
  UNKNOWN = 'Desconocido',
  VIEW_ALL = 'Ver todos',
  FEET = 'ft',
  SUCCESS = '¡Exito!',
  FINISH = 'Finalizar',
  SOMETHING_WENT_WRONG = '¡Ups! Algo salio mal!',
  EMAIL = 'Correo electronico',
  UPLOAD_FILE = 'Subir archivo',
  OPEN_FILE = 'Abrir archivo',
  BACK = 'Atras',
  TENANT_SIGN_IN = 'Portal de inquilino',
  NO_RENTAL_HISTORY_ERROR = 'Por favor, ingrese detalles para al menos una renta previa.',
  CANNOT_PERFORM_SCREENING = 'La verificación no se puede realizar en este momento.',
  CANNOT_MAKE_PAYMENTS = 'Los pagos no están disponibles en este momento.',
  STRIPE_COULD_NOT_BE_REACHED = 'No se pudo conectar con Stripe. Vuelva a intentarlo en un momento',
  PAYMENT_DECLINED = 'Tu pago fue rechazado. Usa otra tarjeta o método de pago.',
  VIEW_SPECIFIC_REASON = 'Ver el motivo específico',
  PAYMENT_FAILED = 'Tu pago no se completó. Inténtalo de nuevo.',
  PAYMENT_DECLINE_UNKNOWN = 'No pudimos completar esta transacción. Comunícate con soporte para recibir ayuda.',
  PAYMENT_DECLINE_INVALID_REQUEST = 'La solicitud de pago no se pudo aceptar tal como se envió. Comunícate con soporte para recibir ayuda.',
  PAYMENT_DECLINE_INVALID_AMOUNT = 'El monto de la transacción no es válido. Revisa el monto o comunícate con soporte.',
  PAYMENT_DECLINE_INVALID_VALUE = 'No se pudieron aceptar uno o más de los datos enviados. Revisa los datos o comunícate con soporte.',
  PAYMENT_DECLINE_UNAUTHORIZED = 'La solicitud de pago fue rechazada porque no se aceptaron las credenciales. Comunícate con soporte para recibir ayuda.',
  PAYMENT_DECLINE_FORBIDDEN = 'Este pago no está permitido. Comunícate con soporte para recibir ayuda.',
  PAYMENT_DECLINE_DUPLICATE_REQUEST = 'Esta solicitud coincide con una anterior. Verifica el registro existente antes de enviar otro pago.',
  PAYMENT_DECLINE_TIMEOUT = 'El proveedor de pagos no respondió a tiempo. Comunícate con soporte para recibir ayuda.',
  PAYMENT_DECLINE_PROVIDER_UNAVAILABLE = 'El proveedor de pagos no está disponible temporalmente. Comunícate con soporte para confirmar el resultado de la transacción.',
  PAYMENT_DECLINE_PROVIDER_ERROR = 'No pudimos completar esta transacción. Comunícate con soporte para recibir ayuda.',
  PAYMENT_DECLINE_PROCESSING_LIMIT_EXCEEDED = 'Esta transacción supera el límite de procesamiento de pagos aplicable. Comunícate con soporte para confirmar los límites permitidos.',
  PAYMENT_DECLINE_PAYMENT_METHOD_LIMIT_EXCEEDED = 'Esta transacción supera un límite de este método de pago. Comunícate con el titular de la cuenta para confirmar los límites aplicables.',
  PAYMENT_DECLINE_PAYMENT_METHOD_VERIFICATION_FAILED = 'No pudimos verificar este método de pago. Usa otro método de pago o comunícate con soporte.',
  PAYMENT_DECLINE_PAYMENT_METHOD_HOLDER_MISMATCH = 'No se pudieron hacer coincidir los datos del titular de la cuenta. Revisa los datos registrados en tu banco o usa otro método de pago.',
  PAYMENT_DECLINE_COLLECT_DECLINED = 'Tu banco no aprobó este pago. Comunícate con tu banco o usa otro método de pago.',
  PAYMENT_DECLINE_COLLECT_INSUFFICIENT_FUNDS = 'El pago no se pudo completar por fondos insuficientes o por haber superado el límite de crédito. Comunícate con el titular de la cuenta o usa otro método de pago.',
  PAYMENT_DECLINE_COLLECT_METHOD_INVALID = 'Este método de pago no se puede usar. Revisa los datos o usa otro método de pago.',
  PAYMENT_DECLINE_COLLECT_METHOD_EXPIRED = 'Este método de pago venció. Usa otro método de pago.',
  PAYMENT_DECLINE_COLLECT_RESTRICTED = 'Este pago no está permitido para este método de pago. Comunícate con tu banco o usa otro método de pago.',
  PAYMENT_DECLINE_COLLECT_REQUIRES_ACTION = 'Se necesita una acción adicional para completar este pago. Comunícate con soporte para recibir ayuda.',
  PAYMENT_DECLINE_KYC_REQUIRED = 'Esta transacción no se pudo aprobar. Comunícate con soporte para recibir ayuda.',
  PAYMENT_DECLINE_KYC_FAILED = 'Esta transacción no se pudo aprobar. Comunícate con soporte para recibir ayuda.',
  PAYMENT_DECLINE_RISK_REJECTED = 'Esta transacción no se pudo aprobar. Comunícate con soporte para recibir ayuda.',
  PAYMENT_DECLINE_SANCTION_RESTRICTED = 'Esta transacción no se pudo aprobar. Comunícate con soporte para recibir ayuda.',
  PAYMENT_DECLINE_INTERNAL_ERROR = 'No pudimos completar esta transacción. Comunícate con soporte para recibir ayuda.',
  BUSINESS_INFO_NOT_FOUND = 'Falta la información comercial.',
  RENTAL_APPLICATION_NOT_FOUND = 'No se pudo encontrar esta solicitud de alquiler.',
  FILE_UPLOAD_FAILED = 'Error al subir el archivo. Inténtalo de nuevo.',
  FILE_NOT_ACCEPTED = 'Uno de tus archivos no se puede subir por su tipo o tamaño. Quítalo e inténtalo de nuevo.',
  FILE = 'Archivo',
  LEASE_INSURANCE_MISSING_FIELDS = 'Falta información obligatoria. Por favor completa todos los campos e intenta nuevamente.',
  LEASE_OR_SIGNATURE_NOT_FOUND = 'No se pudo encontrar el contrato o la firma.',
  FILE_SESSION_RESPONSE_INVALID = 'No se pudo iniciar la subida del archivo. Inténtalo de nuevo.',
  REMOVE = 'Remover',
  APPLICANT_INFORMATION = 'Informacion del solicitante',
  GET_STARTED = 'Tus datos',
  POTENTIAL_UNITS = 'Unidades potenciales',
  UNITS_OF_INTEREST = 'Unidades de interes',
  ALL_UNITS = 'Todas las unidades',
  OPEN_TO_ALL_UNITS = 'Abierto a todas las unidades',
  RENTAL_HISTORY = 'Historial de renta',
  WORK_HISTORY = 'Historial de trabajo y verificacion de ingresos',
  TERM_AND_CONDITIONS = 'Terminos y condiciones',
  CONFIRM_YOUR_IDENTITY = 'Confirma tu identidad',
  PETS_AND_CARS = 'Mascotas y autos',
  QUESTIONS = 'Preguntas',
  RENTAL_APPLICATION = 'Solicitud de renta',
  SUBMIT_A_RENTAL_APPLICATION = 'Enviar una solicitud de renta',
  MAGICDOOR_TERMS = 'Terminos y condiciones de MagicDoor',
  TRANS_UNION_TERMS = 'Terminos y condiciones de TransUnion',
  ADD_RENTAL_HISTORY = 'Agregar historial de renta',
  REASON_FOR_LEAVING = 'Razon para dejar',
  LANDLORD_NAME = 'Nombre del propietario',
  LANDLORD_PHONE = 'Telefono del propietario',
  RENT = 'Renta',
  MOVE_IN_DATE = 'Fecha de entrada',
  MOVE_OUT_DATE = 'Fecha de salida',
  I_HAVE_READ_AND_AGREED_TO_THE_TERMS = 'He leido y aceptado los terminos de servicio',
  ADD_EMPLOYMENT = 'Agregar empleo',
  EMPLOYMENT_HISTORY = 'Historial de empleo',
  I_AM_EMPLOYED = 'Actualmente estoy empleado',
  ANNUAL_INCOME = 'Ingreso anual',
  NAME = 'Nombre',
  PHONE = 'Telefono',
  POSITION = 'Posicion',
  JOB_TITLE = 'Titulo del trabajo',
  SALARY = 'Salario',
  START_SCREENING = 'Iniciar verificación',
  PAYMENT_DETAILS = 'Detalles de pago',
  SUBMIT_ANSWERS = 'Enviar respuestas',
  PAYMENT_PROCESSING = 'Procesando pago ...',
  PAYMENT_PROCESSING_BLURB = 'Tu transaccion esta siendo procesada. Esto puede tomar un par de minutos. Por favor, espera y no cierra la pantalla',
  DONE = 'Listo',
  SUBMITTED = 'Enviada',
  RENTAL_APPLICATION_SUCCESSFULLY_SUBMITTED = 'Felicidades, tu solicitud ya fue enviada.',
  RENTAL_APPLICATION_NOTIFICATION = 'Te contactaremos lo antes posible.',
  CONNECTING_TO_TRANS_UNION = 'Conectando a TransUnion para preparar el cuestionario y iniciar la verificacion de identidad ...',
  CONNECTING_TO_TRANS_UNION_BLURB = 'Por favor, espera y no salgas de esta pagina - estamos obteniendo tu cuestionario y configurando la verificacion de identidad.',
  CONTACT_CUSTOMER_SUPPORT = 'Para completar tu proceso de verificación, por favor contacta a nuestro soporte de cliente en ',
  CONTACT_CUSTOMER_SUPPORT_BLURB = 'Mientras estes en la llamada, por favor, permanece en esta pantalla para actualizaciones en tiempo real. Una vez que tu llamada termine, por favor, permanece en la pagina para el siguiente paso.',
  UNABLE_TO_VERIFY_IDENTITY = 'No podemos verificar tu identidad en linea.',
  RENTER_SCREENING_ID = 'ID de verificación de inquilino= {renterID}',
  PAGE_NOT_FOUND = 'Pagina no encontrada',
  PAGE_NOT_FOUND_BLURB_1 = 'Parece que encontraste la puerta al gran nada, lo sentimos por eso.',
  PAGE_NOT_FOUND_BLURB_2 = 'Por favor, visita nuestra pagina principal para llegar a donde necesitas ir.',
  COMPANY_NOT_FOUND = 'Parece que la pagina que estas buscando no existe. Por favor, revisa la URL o contacta a tu administrador de propiedades para obtener ayuda.',
  FIRST_NAME = 'Nombre',
  LAST_NAME = 'Apellido',
  SSN = 'SSN',
  DATE_OF_BIRTH = 'Fecha de nacimiento',
  VIEW_IN_FULL_SCREEN = 'Abrir en una nueva pestaña',
  WELCOME = 'Bienvenido',
  YOU_HAVE_TO_ACCEPT_THIS_LICENSE_AGREEMENT = 'Tienes que aceptar este acuerdo de licencia',
  PAY = 'Pagar',
  RENTAL_APPLICATION_FEE_BLURB = 'Se requiere pagar una tarifa no reembolsable de {amount} para enviar tu solicitud, que se destinara a los costos de verificación.',
  TEXT_ONLY = 'Solo texto',
  LEASING = 'Arrendamiento',
  CONFIRM = 'Confirmar',
  END_DATE_IS_INVALID = 'Fecha de fin no es valida',
  FIRST_NAME_IS_INVALID = 'Nombre no es valido',
  LAST_NAME_IS_INVALID = 'Apellido no es valido',
  EMAIL_IS_INVALID = 'Email no es valido',
  PHONE_NUMBER_IS_INVALID = 'Telefono no es valido',
  DATE_OF_BIRTH_IS_INVALID = 'Fecha de nacimiento no es valida',
  DATE_OF_BIRTH_IS_GREATER = 'La edad no puede ser mayor a 125 años',
  DATE_OF_BIRTH_IS_LESSER = 'La edad no puede ser menor a 18 años',
  ANNUAL_INCOME_IS_INVALID = 'Ingreso anual no es valido',
  SSN_IS_INVALID = 'SSN no es valido',
  EMPLOYER_NAME_IS_INVALID = 'Nombre del empleador no es valido',
  SALARY_IS_INVALID = 'Salario no es valido',
  POSITION_TITLE_IS_INVALID = 'Position/title is not valid',
  START_DATE_IS_INVALID = 'Fecha de inicio no es valido',
  END_DATE_IS_INVALID_EARLIER = 'La fecha de fin no puede ser anterior a la fecha de inicio',
  ADDRESS_IS_INVALID = 'Direccion no es valido',
  STREET_ADDRESS_1_IS_INVALID = 'Direccion 1 no es valido',
  STREET_ADDRESS_2_IS_INVALID = 'Direccion 2 no es valido',
  REASON_FOR_LEAVING_IS_INVALID = 'La longitud de la razon para dejar no puede exceder 500',
  CITY_IS_INVALID = 'Ciudad no es valido',
  STATE_IS_INVALID = 'Estado no es valido',
  ZIP_CODE_IS_REQUIRED = 'Codigo postal es requerido',
  ZIP_CODE_IS_INVALID = 'El codigo postal de los EE.UU. debe consistir en 5 digitos',
  COUNTRY_IS_INVALID = 'Pais no es valido',
  LANDLORD_NAME_IS_INVALID = 'Nombre del propietario no es valido',
  LANDLORD_PHONE_NUMBER_IS_INVALID = 'Telefono del propietario no es valido',
  RENT_IS_INVALID = 'Renta no es valido',
  MOVE_IN_DATE_IS_INVALID = 'Fecha de entrada no es valido',
  MOVE_OUT_DATE_IS_INVALID = 'Fecha de salida no es valido',
  MOVE_IN_DATE_IS_LATER = 'La fecha de entrada no puede ser posterior a la fecha de salida',
  MOVE_OUT_DATE_IS_EARLIER = 'La fecha de salida no puede ser anterior a la fecha de entrada',
  JOB_TITLE_IS_INVALID = 'Titulo del trabajo no es valido',
  FILE_IS_REQUIRED = 'Archivo es requerido',
  COMPANY_NAME = 'Nombre de la empresa',
  FOLLOW_US = 'Siguenos',
  PROPERTIES = 'Propiedades',
  CONTACT_US = 'Contactanos',
  LET_US_GUIDE_YOU_HOME = 'Permitenos guiarte a tu hogar',
  BANNER_TITLE = 'Descubre un lugar que te encantara vivir',
  SEARCH = 'Buscar',
  PROPERTY_FOR_YOU_TITLE = 'Propiedad para ti',
  PROPERTY_FOR_YOU_SUBTITLE = 'Busca y guarda un par de casas que te gusten y te daremos recomendaciones.',
  PINNED = 'Fijado',
  PRICE = 'Precio',
  MIN = 'Minimo',
  MAX = 'Maximo',
  NO_MIN = 'no minimo',
  NO_MAX = 'no maximo',
  HOME_TYPE = 'Tipo de casa',
  BEDS_AND_BATHS = 'Habitaciones y baños',
  ANY = 'Cualquier',
  SINGLE_FAMILY = 'Familia unica',
  MULTI_FAMILY = 'Familia multiple',
  COMMERCIAL = 'Comercial',
  CONDO = 'Condominio',
  TOWN_HOUSE = 'Casa de vecindario',
  RESET = 'Reiniciar',
  CONTACT_MANAGER = 'Contactar al administrador',
  PET = 'Mascota',
  PETS = 'Mascotas',
  AC = 'Aire acondicionado',
  PARKING = 'Estacionamiento',
  UTILITIES_INCLUDED = 'Utilidades incluidas',
  INTERIOR_AMENITIES = 'Amenidades interiores',
  OUTDOOR_AMENITIES = 'Amenidades al aire libre',
  COMMUNITY_AMENITIES = 'Amenidades comunales',
  OUTDOOR = 'Al aire libre',
  LISTED = 'Listado',
  MONTH = 'Mes',
  SQFT = 'sqft',
  OVERVIEW = 'Resumen',
  HOME_HIGHLIGHTS = 'Destacados de la casa',
  FACTS_AND_FEATURES = 'Facts y caracteristicas',
  LOCAL_INFORMATION = 'Informacion local',
  SELECT_PRICE = 'Seleccionar precio',
  SELECT_HOME_TYPE = 'Seleccionar tipo de casa',
  SELECT_MOVE_IN_DATE = 'Seleccionar fecha de entrada',
  SLIDE_UP_TO_LOAD_MORE = 'Desliza hacia arriba para cargar mas',
  APPLY = 'Aplicar',
  PROPERTY_DETAIL = 'Detalle de la propiedad',
  ZERO_RESULTS_DESC = 'No se encontraron resultados para la direccion proporcionada. Por favor, revisa la direccion y vuelve a intentarlo.',
  MAP_ERROR_DESC = 'Ocurrio un error al cargar el mapa. Por favor, intenta nuevamente mas tarde.',
  SEARCH_FOR_YOUR_DREAM_HOME = 'Busca tu casa soñada',
  ALL_RIGHTS_RESERVED = 'Todos los derechos reservados',
  DBA_TENANT_FRIENDLY_NAME = '"{companyName}" es un nombre comercial que opera como las siguientes entidades legales:',
  DBA_ALSO_OPERATES_AS = '"{companyName}" tambien opera como las siguientes entidades legales:',
  DBA_ENTITY_MAY_VARY = 'La entidad legal responsable puede variar segun el edificio del que seas inquilino o al que estes aplicando.',
  WE_CURRENTLY_DO_NOT_HAVE_ANY_AVAILABLE_UNITS = 'Actualmente no tenemos unidades disponibles, pero siempre puedes enviar una solicitud de renta a nosotros',
  PRIVACY_POLICY = 'Politica de privacidad',
  ACCEPT_TERMS_AND_CONDITIONS_PROCEED = 'Por favor acepta los terminos y condiciones para continuar.',
  TERMS_OF_SERVICE = 'Terminos de servicio',
  EQUAL_HOUSING_OPPORTUNITY = 'Igualdad de oportunidades',
  FILTER = 'Filtrar',
  FILTERS = 'Filtros',
  SIGN_HERE = 'Firmar aqui!',
  ALLOWED = 'Permitido',
  MONTHLY_PET_FEES = 'Tarifa mensual de mascotas',
  NO_LIMIT = 'Sin limite',
  PET_DEPOSIT = 'Deposito de mascota',
  SMALL_WEIGHT = 'Pequeño (menos de 22.0462 libras)',
  MEDIUM_WEIGHT = 'Mediano (22.0462 - 55.1156 libras)',
  LARGE_WEIGHT = 'Grande (55.1156 - 110.2311 libras)',
  CATS = 'Gatos',
  DOGS = 'Perros',
  OTHER = 'Otro',
  FISH = 'Peces',
  BIRDS = 'Pajaros',
  REPTILES = 'Reptiles',
  OTHERS = 'Otros',
  ALL_ALLOWED = 'Todos permitidos',
  DESIRED_MOVE_IN_DATE_IS_INVALID = 'Fecha de entrada deseada no es valida',
  DESIRED_MOVE_IN_DATE = 'Fecha de entrada deseada',
  CURRENT_UNIT_IS_UNLISTED = 'La unidad a la que estás aplicando ya no está listada.',
  PLEASE_ANSWER_THIS_QUESTION = 'Por favor, responde esta pregunta',
  COMMENT_CANNOT_EXCEED = 'El comentario no puede exceder 500 caracteres',
  YOU_CAN_ADD_A_COMMENT_TO_THE_MANAGER = 'Puedes agregar un comentario al administrador',
  COMMENT = 'Comentario',
  PET_NAME_IS_INVALID = 'Nombre de la mascota no es valido',
  BREED_IS_INVALID = 'Raza no es valido',
  PET_WEIGHT_IS_INVALID = 'Peso de la mascota no es valido',
  AGE_IS_INVALID = 'Edad no es valida',
  GENDER_IS_INVALID = 'Genero no es valido',
  SPAY_NEUTER_STATUS_IS_INVALID = 'Estado de esterilizacion no es valido',
  SERVICE_ANIMAL_STATUS_IS_INVALID = 'Estado de animal de servicio no es valido',
  EMOTIONAL_SUPPORT_ANIMAL_STATUS_IS_INVALID = 'Estado de animal de soporte emocional no es valido',
  CAR_MAKE_IS_INVALID = 'Marca del coche no es valido',
  MODEL_IS_INVALID = 'Modelo no es valido',
  YEAR_IS_INVALID = 'Año no es valido',
  LICENSE_PLATE_IS_INVALID = 'Placa de licencia no es valido',
  STATE_REGISTRATION_IS_INVALID = 'Registro de estado no es valido',
  CAR_COLOR_IS_INVALID = 'Color del coche no es valido',
  YOU_HAVE_SUCCESSFULLY_SIGNED_THE_LEASE = 'Has firmado el contrato con exito. Manten un ojo en las futuras notificaciones de nosotros.',
  BREED = 'Raza',
  WEIGHT = 'Peso',
  AGE = 'Edad',
  GENDER = 'Genero',
  CAR = 'Coche',
  CARS = 'Coches',
  CAR_MAKE = 'Marca del coche',
  MODEL = 'Modelo',
  YEAR = 'Año',
  LICENSE_PLATE = 'Placa de licencia',
  STATE_REGISTRATION = 'Registro de estado',
  COLOR = 'Color',
  SPAYED_OR_NEUTERED = 'Mi mascota esta esterilizada/desterilizada',
  SERVICE_ANIMAL = 'Mi mascota es un animal de servicio',
  EMOTIONAL_SUPPORT_ANIMAL = 'Mi mascota es un animal de soporte emocional',
  MM_DD_YYYY = 'MM/DD/YYYY',
  OPERATION_FAILED_PLEASE_TRY_AGAIN_LATER = 'Operación fallida, por favor intenta nuevamente mas tarde',
  REMOVE_SELECTED = 'Remover seleccionado',
  PURCHASE_RENTAL_INSURANCE = 'Comprar seguro de renta',
  UNAVAILABLE = 'Documento no encontrado',
  DOCUMENT_NOT_AVAILABLE = 'El documento ya no esta disponible. Por favor, contacta a tu administrador de propiedades para obtener ayuda.',
  LINK_EXPIRED_TITLE = 'Enlace caducado',
  LINK_EXPIRED_MESSAGE = 'Este enlace ha caducado. Por favor, contacta a tu administrador de propiedades para solicitar una copia actualizada de tu documento.',
  DO_YOU_HAVE_A_PET = '¿Tienes una mascota?',
  ADD_NEW_PET = 'Agregar una nueva mascota',
  DO_YOU_HAVE_A_CAR = '¿Tienes un coche?',
  ADD_NEW_CAR = 'Agregar un nuevo coche',
  NO_UNITS_LISTED = 'Actualmente, no hay unidades listadas',
  OR_LESS = 'o menos',
  OR_MORE = 'o mas',
  LIST_SEPARATOR = '{first}, {rest}',
  PRICE_OR_MORE = '{price} o mas',
  PRICE_OR_LESS = '{price} o menos',
  PRICE_RANGE = '{min}-{max}',
  MIN_BEDS = '{count}+ rec',
  MIN_BATHS = '{count}+ baños',
  MOVE_IN_DATE_FROM = 'Fecha de entrada {date}',
  PETS_ALLOWED_TYPES = 'Permitido ({types})',
  MONTHLY_PET_FEES_AMOUNT = '{amount} Tarifa mensual de mascotas',
  PET_DEPOSIT_AMOUNT = 'Deposito de mascota: {amount}',
  ANY_PRICE = 'Cualquier precio',
  NO_MORE_RESULTS = 'No hay mas resultados',
  BY_SUBMITTING_THIS_APPLICATION_BLURB = 'Al enviar este formulario, aceptas dar consentimiento a {companyName} para recibir notificaciones de cuenta y mensajes de comunicaciones directas de la empresa, al numero proporcionado, incluyendo mensajes enviados por autodialer. La frecuencia de los mensajes puede variar. El consentimiento no es una condicion de compra. Los costos de mensajes y datos pueden aplicarse. Desuscribete en cualquier momento respondiendo STOP. Responde a HELP para obtener ayuda. ',
  SEARCH_UNITS = 'Buscar unidades...',
  SEARCH_ADDRESS = 'Buscar direccion',
  LANDLORD_EMAIL = 'Correo del propietario',
  LANDLORD_EMAIL_REQUIRED_FOR_CONSENT = 'El correo del propietario es obligatorio para verificar tu historial de arrendamiento',
  VERIFICATION_CONSENT = 'Autorizo a {companyName} a contactar a este propietario para verificar mi historial de arrendamiento.',
  SUPPORTING_DOCUMENTS = 'Documentos de respaldo',
  OOPS = '¡Ups!',
  APPLICATION_NOT_QUALIFIED_TITLE = 'Solicitud incompleta',
  APPLICATION_NOT_QUALIFIED_BODY = 'Por favor completa lo siguiente antes de enviar:',
  VALIDATION_FIRST_NAME_REQUIRED = 'El nombre es obligatorio',
  VALIDATION_LAST_NAME_REQUIRED = 'El apellido es obligatorio',
  VALIDATION_EMAIL_REQUIRED = 'El correo electrónico es obligatorio',
  VALIDATION_PHONE_REQUIRED = 'El número de teléfono es obligatorio',
  VALIDATION_SSN_REQUIRED = 'El número de Seguro Social es obligatorio',
  VALIDATION_DATE_OF_BIRTH_REQUIRED = 'La fecha de nacimiento es obligatoria',
  VALIDATION_RESIDENTIAL_HISTORY_REQUIRED = 'Se requiere al menos una entrada del historial de residencia',
  VALIDATION_REQUIRED_QUESTIONS_NOT_ANSWERED = 'Todas las preguntas obligatorias deben responderse antes de enviar la solicitud',
  VALIDATION_ALREADY_SUBMITTED = 'Esta solicitud ya ha sido enviada',
  VALIDATION_REQUIRED_FILES_MISSING = 'Faltan documentos requeridos',
  VALIDATION_TERMS_NOT_ACCEPTED = 'No se han aceptado los términos',
  APPLY_NOW = 'Aplicar ahora',
  SUMMARY = 'Resumen',
  APPLICATION_EDIT_WARNING = 'No podrás editar tu solicitud después del envío. Por favor revisa tu información cuidadosamente antes de continuar.',
  APPLICATION_LOCKED_WARNING = 'La solicitud ha sido enviada y ahora está bloqueada. No es posible realizar cambios en los datos ingresados previamente.',
  EDIT = 'Editar',
  CHANGE = 'Cambiar',
  UNIT = 'Unidad',
  SPECIAL_INFO = 'Información Especial',
  MAKE_AND_MODEL = 'Marca y Modelo',
  EMPLOYMENT = 'Empleo',
  EMPLOYMENT_HISTORY_REQUIRED = 'Por favor agregue al menos un registro de empleo',
  TEXT_TOO_LONG = 'El texto no puede exceder 500 caracteres',
  PERMISSION_TO_TEXTING_NOTICE = 'Aviso: No marcando esta casilla, podrás perder información importante sobre tu solicitud de renta. Si estás seguro de que deseas continuar, simplemente haz clic en Siguiente otra vez.',
  COULD_NOT_LOAD_PDF_FILE = 'No se pudo cargar el archivo PDF!',
  WATER_AND_SEWER = 'Agua y alcantarillado',
  ELECTRICITY = 'Electricidad',
  GAS = 'Gas',
  TRASH = 'Basura',
  INTERNET_CABLE = 'Internet/cable',
  HEATING_AIR_CONDITIONING = 'Calefacción/aire acondicionado',
  IN_UNIT_WASHER_DRYER = 'Lavadora/secadora en la unidad',
  DISHWASHER = 'Lavaplatos',
  MICROWAVE = 'Microondas',
  STAINLESS_STEEL_APPLIANCES = 'Electrodomésticos de acero inoxidable',
  HARDWOOD_FLOORING = 'Pisos de madera dura',
  CENTRAL_AC_HEATING = 'Aire acondicionado/calefacción central',
  WALK_IN_CLOSETS = 'Clósets empotrados',
  HIGH_SPEED_INTERNET = 'Internet de alta velocidad',
  FIREPLACE = 'Chimenea',
  PATIO = 'Patio',
  BBQ_GRILLS_OR_PICNIC_AREA = 'Asadores o área de picnic',
  ROOFTOP_DECK = 'Terraza en la azotea',
  PARKING_SPACE = 'Espacio de estacionamiento',
  GYM = 'Gimnasio',
  SWIMMING_POOL = 'Piscina',
  COMMUNITY_CLUBHOUSE = 'Salón comunitario',
  PLAYGROUND_OR_DOG_PARK = 'Área de juegos o parque para perros',
  LAUNDRY_FACILITIES = 'Instalaciones de lavandería',
  PARKING_OR_GARAGE = 'Estacionamiento o cochera',
  SECURITY_OR_CONTROLLED_ACCESS = 'Seguridad 24/7 o acceso controlado',
  E_SIGNATURE_CONSENT_TITLE = 'Divulgacion de registros electronicos y firma',
  E_SIGNATURE_CONSENT_BODY = 'Al seleccionar "Acepto", consiento realizar negocios electronicamente, incluyendo la firma de documentos mediante firmas electronicas. Reconozco que he leido y acepto los terminos de uso para firmas electronicas.',
  E_SIGNATURE_CONSENT_AGREE = 'Acepto el uso de registros y firmas electronicas',
  E_SIGNATURE_CONSENT_ERROR = 'Debe aceptar los terminos de firma electronica para continuar',
  E_SIGNATURE_DISCLOSURE_LINK = 'Revisar la divulgacion completa de registros electronicos y firma',
  START_SIGNING = 'Iniciar firma',
  FILE_KIND_GOVERNMENT_ID = 'Identificación oficial',
  FILE_KIND_BANK_STATEMENT = 'Estado de cuenta bancario',
  FILE_KIND_PAY_STUB = 'Recibo de pago',
  FILE_KIND_TAX_RETURN = 'Declaracion de impuestos',
  FILE_KIND_OFFER_LETTER = 'Carta de oferta',
  FILE_KIND_REFERENCE_LETTER = 'Carta de recomendacion',
  FILE_KIND_EMPLOYMENT_VERIFICATION = 'Verificacion de empleo',
  FILE_KIND_OTHER = 'Otros documentos',
  UPLOADING_FILE_PROGRESS = 'Subiendo {current} de {total}: {fileName}',
  TERMS_ACCEPTED_AT = 'Aceptado el {date}',
  VERIFYING_YOUR_IDENTITY = 'Estamos verificando tu identidad. Un momento por favor...',
  FETCHING_FROM_TRANSUNION = 'Obteniendo datos de TransUnion',
  LOADING_APPLICATION = 'Cargando tu solicitud...',
  LOADING_PAYMENT_FINALIZING = 'Esperando que se complete el pago...',
  LOADING_PAYMENT_INFO = 'Cargando los detalles de pago...',
  LOADING_TAKING_LONGER = 'Esto esta tardando mas de lo esperado. Si no se resuelve pronto, por favor contacta a soporte.',
  SUBMIT_BLOCKED_MAGICDOOR_TERMS = 'Acepta los terminos de servicio de MagicDoor para continuar.',
  SUBMIT_BLOCKED_TRANSUNION_TERMS = 'Acepta los terminos de servicio de TransUnion para continuar.',
  SUBMIT_BLOCKED_MISSING_REQUIRED_FIELDS = 'Completa los campos obligatorios restantes de tu solicitud.',
  SUBMIT_BLOCKED_HEADING = 'Antes de enviar:',
  MISSING_REQUIRED_DOCUMENT = 'Sube el documento obligatorio: {name}',
  NUMBERED_ITEM = '{label} {number}',
  UPLOADING_FILE_COUNT = 'Subiendo {current} de {total}',
  GENDER_MALE = 'Macho',
  GENDER_FEMALE = 'Hembra',
  APPLICATION_STATUS_DRAFT = 'Borrador',
  APPLICATION_STATUS_RETRACTED = 'Retirada',
  JOB_AT_EMPLOYER = '{jobTitle} en {employer}',
  SPAYED_NEUTERED_LABEL = 'Esterilizado/Castrado',
  SERVICE_ANIMAL_LABEL = 'Animal de servicio',
  EMOTIONAL_SUPPORT_ANIMAL_LABEL = 'Animal de apoyo emocional',
  UPLOAD_REQUIRED_DOCUMENTS = 'Documentos obligatorios',
  INFO_UPDATE_MODE_BADGE = 'Actualización solicitada',
  INFO_UPDATE_BADGE_HINT = '{companyName} te ha pedido revisar y actualizar tu solicitud.',
  INFO_UPDATE_WELCOME = 'Bienvenido',
  INFO_UPDATE_WELCOME_TITLE = 'Actualiza tu solicitud',
  INFO_UPDATE_WELCOME_BODY = '{companyName} te ha pedido revisar y actualizar partes de tu solicitud. Usa el menú de la izquierda para editar cualquier sección. Tus cambios se guardan a medida que avanzas. Cuando termines, haz clic en Listo.',
  INFO_UPDATE_WELCOME_GET_STARTED = 'Comenzar',
  INFO_UPDATE_PERSONAL_INFORMATION = 'Información personal',
  INFO_UPDATE_DONE = 'Listo',
  INFO_UPDATE_DONE_PROMPT = '¿Terminaste? Haz clic en Listo para avisar a {companyName} que tus cambios están listos.',
  INFO_UPDATE_DONE_CONFIRM_TITLE = '¿Enviar tus cambios?',
  INFO_UPDATE_DONE_CONFIRM_BODY = 'Una vez enviado, este enlace de actualización ya no podrá usarse. {companyName} deberá enviar un nuevo código si necesitas cambiar algo más.',
  INFO_UPDATE_DONE_CONFIRM_OK = 'Enviar',
  INFO_UPDATE_DONE_CONFIRM_CANCEL = 'Seguir editando',
  INFO_UPDATE_THANK_YOU_TITLE = 'Gracias — tu actualización ha sido enviada',
  INFO_UPDATE_THANK_YOU_BODY = '{companyName} revisará tus cambios. Puedes cerrar esta ventana.',
  INFO_UPDATE_ERROR_LOCKED = 'Este enlace de actualización ya no es válido. Pide a {companyName} que envíe uno nuevo.',
  INFO_UPDATE_ERROR_EXPIRED = 'Este enlace de actualización ha expirado. Contacta a {companyName} para obtener uno nuevo.',
  INFO_UPDATE_ERROR_INVALID = 'Este enlace de actualización no es válido. Contacta a {companyName} para obtener ayuda.',
  INFO_UPDATE_ERROR_COMPLETED = 'Esta actualización ya fue enviada. No se necesitan más cambios.',
  INFO_UPDATE_ERROR_CANCELLED = 'El enlace de actualización fue cancelado por {companyName}. Comunícate con ellos si aún necesitas hacer cambios.',
  INFO_UPDATE_ERROR_UNCERTAIN = 'No pudimos confirmar si este enlace aún está activo. Puedes seguir editando, pero tus cambios pueden no guardarse si el enlace ya se usó o expiró. Contacta a tu administrador de propiedades si necesitas un enlace nuevo.',
  INFO_UPDATE_REFRESH_TO_VERIFY = 'Actualizar para verificar',
  LANDLORD_VERIFICATION_TITLE = 'Verificación de historial de alquiler',
  LANDLORD_VERIFICATION_INTRO = 'Por favor confirma el historial de alquiler a continuación para {applicantName}.',
  LANDLORD_VERIFICATION_APPLICANT = 'Solicitante',
  LANDLORD_VERIFICATION_ADDRESS = 'Dirección',
  LANDLORD_VERIFICATION_MOVE_IN = 'Fecha de mudanza',
  LANDLORD_VERIFICATION_MOVE_OUT = 'Fecha de salida',
  LANDLORD_VERIFICATION_RESPONSE = 'Tu respuesta',
  LANDLORD_VERIFICATION_VERIFIED = 'Verificado',
  LANDLORD_VERIFICATION_DECLINED = 'Rechazado',
  LANDLORD_VERIFICATION_REJECTED = 'Denegado',
  LANDLORD_VERIFICATION_NOTES = 'Notas (opcional)',
  LANDLORD_VERIFICATION_HAD_LATE_PAYMENTS = 'El inquilino tuvo pagos tardíos',
  LANDLORD_VERIFICATION_WAS_EVICTED = 'El inquilino fue desalojado',
  LANDLORD_VERIFICATION_WOULD_RECOMMEND = 'Recomendaría a este inquilino',
  LANDLORD_VERIFICATION_SUBMIT = 'Enviar respuesta',
  LANDLORD_VERIFICATION_SUBMITTING = 'Enviando...',
  LANDLORD_VERIFICATION_THANK_YOU_TITLE = 'Gracias',
  LANDLORD_VERIFICATION_THANK_YOU_BODY = 'Tu respuesta ha sido registrada.',
  LANDLORD_VERIFICATION_ALREADY_COMPLETE_TITLE = 'Esta verificación ya está completa',
  LANDLORD_VERIFICATION_ALREADY_COMPLETE_BODY = 'Este enlace ya se utilizó para enviar una respuesta.',
  LANDLORD_VERIFICATION_INVALID_LINK_TITLE = 'Enlace no encontrado',
  LANDLORD_VERIFICATION_INVALID_LINK_BODY = 'Este enlace de verificación es inválido o ha expirado.',
  LANDLORD_VERIFICATION_MAGIC_RIBBON = 'Verificación con MagicDoor — la plataforma de gestión inmobiliaria con IA que usa {companyName}.',
  LANDLORD_VERIFICATION_MAGIC_FOOTER_TITLE = '{companyName} usa MagicDoor',
  LANDLORD_VERIFICATION_MAGIC_FOOTER_BODY = 'La plataforma de gestión inmobiliaria con IA — arrendamiento, mantenimiento y contabilidad en un solo lugar. Gratis hasta 10 contratos.',
  LANDLORD_VERIFICATION_MAGIC_LEARN_MORE = 'Más información',
  LANDLORD_VERIFICATION_MAGIC_THANK_YOU_TITLE = '¿Cansado de perseguir verificaciones de arrendadores por correo?',
  LANDLORD_VERIFICATION_MAGIC_THANK_YOU_BODY = 'MagicDoor automatiza esto — y el resto de la gestión inmobiliaria. La IA hace el trabajo repetitivo para que te enfoques en tus inquilinos. Gratis para tus primeros 10 contratos.',
  LANDLORD_VERIFICATION_MAGIC_TRY_FREE = 'Prueba MagicDoor gratis',
  LANDLORD_VERIFICATION_VERIFIER_NAME = 'Tu nombre',
  LANDLORD_VERIFICATION_VERIFIER_NAME_HINT = 'Útil para nuestros registros',
  LANDLORD_VERIFICATION_WANTS_MAGICDOOR_INFO = 'Me gustaría saber más sobre MagicDoor para mis propias propiedades.',
  LANDLORD_VERIFICATION_SUBMITTED_BY = 'Enviado por {verifierName}',
  LANDLORD_VERIFICATION_YOUR_PROPERTY_MANAGER = 'Su administrador de propiedades',
  LANDLORD_VERIFICATION_RESPONSE_REQUIRED = 'Elija una respuesta antes de enviar.',
  INSURANCE_LINK_NOT_FOUND = 'No se pudo cargar la oferta de seguro. Vuelva a cargar la página e inténtelo de nuevo.',
  CO_APPLICANTS_STEP_LABEL = 'Co-solicitantes',
  CO_APPLICANTS_TITLE = 'Invitar co-solicitantes',
  CO_APPLICANTS_INTRO = 'Si otras personas alquilan contigo, invítalas para que cada una llene su parte de la solicitud. Puedes omitir esto y continuar.',
  CO_APPLICANTS_LIST_HEADING = 'Ya invitados',
  CO_APPLICANTS_NONE_INVITED = 'Aún no has invitado a nadie.',
  CO_APPLICANTS_ADD_HEADING = 'Agregar un co-solicitante',
  CO_APPLICANTS_FIRST_NAME = 'Nombre',
  CO_APPLICANTS_LAST_NAME = 'Apellido',
  CO_APPLICANTS_EMAIL = 'Correo electrónico',
  CO_APPLICANTS_EMAIL_HINT = 'Necesario para enviar la invitación',
  CO_APPLICANTS_PHONE = 'Teléfono',
  CO_APPLICANTS_MESSAGE = 'Mensaje personal (opcional)',
  CO_APPLICANTS_SEND_INVITE = 'Enviar invitación',
  CO_APPLICANTS_SENDING = 'Enviando...',
  CO_APPLICANTS_INVITE_FAILED = 'No se pudo enviar la invitación. Inténtalo de nuevo.',
  CO_APPLICANTS_NO_EMAIL_NOTE = 'Sin correo — la invitación no se enviará automáticamente.',
  SIGNING_OFFERS_DW_TITLE = 'Aviso: la exención de daños aplica a este contrato',
  SIGNING_OFFERS_DW_SUBTITLE = 'Información de tu administrador de propiedad — no necesitas hacer nada ahora.',
  SIGNING_OFFERS_DW_NOTE = 'Tu administrador habilitó el programa de exención de daños. Como no hay un seguro de inquilino válido registrado, el cargo comienza automáticamente después del período de gracia. Sube una póliza en cualquier momento para evitar este cargo.',
  SIGNING_OFFERS_DW_MONTHLY_FEE = 'Cargo mensual de exención',
  SIGNING_OFFERS_DW_BILLING_STARTS = 'La facturación inicia',
  SIGNING_OFFERS_DW_BILLING_AFTER = 'después del {date}',
  SIGNING_OFFERS_DW_STATUS = 'Estado',
  SIGNING_OFFERS_DW_ENROLLED = 'Actualmente inscrito',
  SIGNING_OFFERS_DW_OPTED_OUT_TITLE = 'Elegibilidad de exención de daños',
  SIGNING_OFFERS_DW_OPTED_OUT_BODY = 'Antes optaste por no participar en el programa de exención de daños. Puedes restaurar la elegibilidad si quieres que el programa aplique de nuevo.',
  SIGNING_OFFERS_DW_RESTORE = 'Restaurar elegibilidad',
  SIGNING_OFFERS_DW_RESTORED_TITLE = 'Elegibilidad restaurada',
  SIGNING_OFFERS_DW_RESTORED_BODY = 'Tu contrato puede volver a entrar al proceso de exención de daños cuando el programa revise elegibilidad. Esto no significa que ya estés inscrito o cubierto.',
  SIGNING_OFFERS_RBP_TITLE = 'Beneficios para residentes, disponibles para ti',
  SIGNING_OFFERS_RBP_SUBTITLE = 'Ofrecidos por tu administrador. Opcional — únete solo si quieres los beneficios.',
  SIGNING_OFFERS_RBP_PRICE_HINT = 'El precio se muestra al confirmar',
  SIGNING_OFFERS_RBP_JOIN = 'Unirme',
  SIGNING_OFFERS_RBP_JOINED = 'Unido',
  SIGNING_OFFERS_RBP_FOOTNOTE = 'Facturación mensual en tu cuenta de renta · cancela en cualquier momento después del período de compromiso',
  SIGNING_OFFERS_RBP_NO_THANKS = 'No, gracias',
  SIGNING_OFFERS_RBP_CONFIRM_TITLE = '¿Unirte a {name}?',
  SIGNING_OFFERS_RBP_JOINED_TITLE = 'Te uniste a {name}',
  SIGNING_OFFERS_RBP_CONFIRM_JOIN = 'Confirmar y unirme',
  SIGNING_OFFERS_RBP_LOADING_QUOTE = 'Cargando términos actuales…',
  SIGNING_OFFERS_RBP_NOT_AVAILABLE = 'No disponible por ahora',
  SIGNING_OFFERS_RBP_MONTHLY_AMOUNT = 'Monto mensual',
  SIGNING_OFFERS_RBP_BENEFITS_START = 'Los beneficios inician',
  SIGNING_OFFERS_RBP_COMMITMENT_ENDS = 'El compromiso termina',
  SIGNING_OFFERS_RBP_CHARGED_VIA = 'Se cobra por',
  SIGNING_OFFERS_RBP_RENT_ACCOUNT = 'Tu cuenta de renta',
  SIGNING_OFFERS_RBP_LOCK_NOTE = 'El primer cargo ocurre después — hoy no se factura nada. Esta confirmación refleja los términos actuales al confirmar.',
  SIGNING_OFFERS_PER_MONTH = '{amount} / mes',
  RESIDENT_BENEFIT_REASON_UNAVAILABLE = 'Este paquete no está disponible en este momento.',
  RESIDENT_BENEFIT_REASON_LEASE_NOT_ACTIVE = 'Este paquete solo está disponible con un contrato activo.',
  RESIDENT_BENEFIT_REASON_NO_LONGER_OFFERED = 'Este paquete ya no se ofrece para tu contrato.',
  RESIDENT_BENEFIT_REASON_ALREADY_JOINED = 'Ya se unió a este paquete.',
  COMPANY_LOGO = 'Logotipo de la empresa',
}
